import React from 'react';
import loadable from '@loadable/component';

export default loadable(
    () => import(/* webpackChunkName: "LazyOrderDetailsChunk" */ './OrderDetailsConnect'),
    {
        fallback: <div>Loading...</div>,
    }
);
